import { cn } from '../../lib/utils';

/**
 * The rendered SVG surface for a Mermaid diagram. Pure presentation: compile
 * the source with `useMermaidSvg` and let the caller (see `MermaidBlock`)
 * decide what a pending or failed render looks like.
 */
export function MermaidSvg({ svg, className }: { svg: string | null; className?: string }) {
  return (
    <div
      className={cn('flex justify-center overflow-x-auto', className)}
      data-testid="mermaid-diagram"
      // Mermaid runs with `securityLevel: 'strict'`, which sanitizes the SVG
      // (DOMPurify) and strips scripts before it is handed back to us.
      // Always pass an object: `undefined` would leave React holding on to
      // the previously injected markup instead of clearing it.
      dangerouslySetInnerHTML={{ __html: svg ?? '' }}
    />
  );
}
